(function (): void {
    if (document.querySelector(".js-modal-form") === null) return;

    const openModal = (modal: HTMLElement): void => {
        modal.style.display = "flex";
    };

    const closeModal = (modal: HTMLElement): void => {
        modal.style.display = "none";
    };

    const setupModalClose = (modal: HTMLElement): void => {
        modal.addEventListener("click", (e: MouseEvent) => {
            const target = e.target;

            if (!(target instanceof Element)) return;

            if (target.closest(".modal-form__close") || target === modal) {
                closeModal(modal);
            }
        });
    };

    // Move each .modal-form-block into its closest .js-modal-form container
    // so navigation by data-formid works regardless of DOM source order
    document.querySelectorAll<HTMLElement>(".modal-form-block").forEach((modal) => {
        const container = modal.closest<HTMLElement>(".js-modal-form");
        if (!container) return;
        container.appendChild(modal);
    });

    // Trigger buttons — open the modal matching their data-id attribute
    document.querySelectorAll<HTMLElement>(".js-modal-trigger").forEach((button) => {
        button.addEventListener("click", () => {
            const id = button.dataset["id"];
            const root = button.closest<HTMLElement>(".js-modal-form");
            if (!root) return;

            const modal: HTMLElement | null =
                (id !== undefined
                    ? root.querySelector<HTMLElement>(`[data-formid='${id}']`)
                    : null) ??
                root.querySelector<HTMLElement>(".js-modal-form-block");

            if (!modal) return;

            openModal(modal);
            setupModalClose(modal);
        });
    });

    // Next navigation — close current modal, open the one with formid + 1
    document.querySelectorAll<HTMLElement>(".js-modal-navigation .modal__next").forEach((button) => {
        button.addEventListener("click", () => {
            const currentModal = button.closest<HTMLElement>(".modal-form-block");
            if (!currentModal) return;

            const currentId = Number.parseInt(currentModal.dataset["formid"] ?? "0", 10);
            const root = currentModal.closest<HTMLElement>(".js-modal-form");
            if (!root) return;

            closeModal(currentModal);

            const nextModal = root.querySelector<HTMLElement>(`[data-formid='${currentId + 1}']`);

            if (!nextModal) return;

            openModal(nextModal);
            setupModalClose(nextModal);
        });
    });

    // Prev navigation — close current modal, open the one with formid - 1
    document.querySelectorAll<HTMLElement>(".js-modal-navigation .modal__prev").forEach((button) => {
        button.addEventListener("click", () => {
            const currentModal = button.closest<HTMLElement>(".modal-form-block");
            if (!currentModal) return;

            const currentId = Number.parseInt(currentModal.dataset["formid"] ?? "0", 10);
            const root = currentModal.closest<HTMLElement>(".js-modal-form");
            if (!root) return;

            closeModal(currentModal);

            const prevModal = root.querySelector<HTMLElement>(`[data-formid='${currentId - 1}']`);

            if (!prevModal) return;

            openModal(prevModal);
            setupModalClose(prevModal);
        });
    });
})();
